import { render, staticRenderFns } from "./AccountDetails.vue?vue&type=template&id=9ad4f74a&scoped=true"
import script from "./AccountDetails.vue?vue&type=script&lang=js"
export * from "./AccountDetails.vue?vue&type=script&lang=js"
import style0 from "./AccountDetails.vue?vue&type=style&index=0&id=9ad4f74a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ad4f74a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ad4f74a')) {
      api.createRecord('9ad4f74a', component.options)
    } else {
      api.reload('9ad4f74a', component.options)
    }
    module.hot.accept("./AccountDetails.vue?vue&type=template&id=9ad4f74a&scoped=true", function () {
      api.rerender('9ad4f74a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/userDetails/components/AccountDetails.vue"
export default component.exports